<template>
  <Header />
  <div class="section container">
    <div class="content">
      <div class="heading">
        <h1>Confirm Category</h1>
      </div>
      <div class="order-info">
        <div>Order Number: #{{ order.order_number }}</div>
        <div>Recipient: {{ order.customer.first_name }} {{ order.customer.last_name }}</div>
      </div>
      <div class="form">
        <div class="form-group">
          <label class="form-label" for="savedAddress">Seeding Category*</label>
          <div v-for="category in categories" :key="category.id" class="order-category-container">
            <div class="order-category-radio-container">
              <input v-model="selectedCategory" :value="category.id" type="radio">
            </div>
            <span class="order-category-name">{{ category.name }}</span>
          </div>
        </div>
      </div>
      <button :disabled="!selectedCategory" class="btn btn--primary" @click="updateOrderCategory()">Continue</button>
    </div>
  </div>

</template>

<script>
import Header from '../components/Header.vue';
import api from '@/api';

export default {
  name: 'AssignCategory',
  components: {
    Header
  },
  data() {
    return {
      order: {
        id: this.$route.params.orderid,
        customer: {
          first_name: '',
          last_name: ''
        }
      },
      categories: [],
      selectedCategory: null
    }
  },
  methods: {
    updateOrderCategory() {
      api.updateOrder(this.order.id, { category_id: this.selectedCategory } ).then(() => {
        this.$router.push('/confirm-order/'+this.order.order_number);
      })
    }
  },
  mounted() {
    this.axios({
      method: 'get',
      url: `/v1/orders/numbered/${this.order.id}.json`,
    })
    .then(response => {
      this.requestCompleted = true;
      this.order = response.data.record;

      if (this.order.financial_status === "pending") {
        api.getCustomer(this.order.customer.id).then(response => {
          this.savedAddresses = response.customer_addresses;
          const first_name = response.first_name
          const last_name = response.last_name
          this.defaultAddress = this.savedAddresses.find(address => address.default);
          const { address1, address2, city, zip, state: province, phone, country } = this.defaultAddress || {};
          this.shipping = { address1, address2, city, province, zip, phone, country, first_name, last_name };
          }).catch((error) => { console.warn(error.message) });
      } else {
        this.redirectToOrders()
      }
    })
   .catch((error) => { console.log(error) });

    api.getOrderCategories().then(res => {
      this.categories = res.data.records
    })
  }
}
</script>

<style scoped>
.order-category-container {
  width: 100%;
  height: 45px;
  background-color: white;
  border: 1px solid #E5E5E5;
  display: flex;
  margin-bottom: 10px;
  align-items: center;
}

.order-category-radio-container {
  height: 43px;
  width: 45px;
  background-color: white;
  border-right: 1px solid #E5E5E5;
  display: flex;
  align-items: center;
  justify-content: center;
}

.order-category-name {
  margin-left: 7px;
}

input[type='radio'] {
  accent-color: black;
}
</style>
